const reCaptegoEmail =
  /.*@captego\.(com|dk|net|co\.uk|com\.test-google-a\.com)$/i

export function isCaptegoEmail(email: string = '') {
  return reCaptegoEmail.test(email)
}
